import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

const ListItem = styled.li`
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    font-weight: 600;

`;

const Stat = styled.strong`
    color: ${COLORS.mlbWhite};
    font-weight: 700;
    white-space: nowrap;
`;

const Stats = ({ data }) => {

    return (
        <ul>
            {data.map(({ label, value }, i) => (
                <ListItem key={i}>
                    {`${label}: `}
                    <Stat>{ `${ value ?? '-' }` }</Stat>
                </ListItem>
            ))}
        </ul>
    );

};

Stats.propTypes = {
    data: PropTypes.array,
};

Stats.defaultProps = {
    data: [],
};

export default Stats;
